package cz.lhoracek.mapl.di

import cz.lhoracek.mapl.data.repository.FirestoreSessionRepository
import cz.lhoracek.mapl.data.repository.KnownSessionIds
import cz.lhoracek.mapl.data.repository.SessionRepository
import cz.lhoracek.mapl.ui.screens.addround.AddRoundViewModel
import cz.lhoracek.mapl.ui.screens.home.HomeViewModel
import cz.lhoracek.mapl.ui.screens.newsession.NewSessionViewModel
import cz.lhoracek.mapl.ui.screens.session.SessionViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val appModule = module {
    single { KnownSessionIds() }
    single<SessionRepository> { FirestoreSessionRepository(get()) }

    viewModelOf(::HomeViewModel)
    viewModelOf(::NewSessionViewModel)
    viewModel { (sessionId: String) -> SessionViewModel(get(), sessionId) }
    viewModel { (sessionId: String) -> AddRoundViewModel(get(), sessionId) }
}
